import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';

// WI-1523 flip switch: set REACT_APP_LOOP_AUTH_URL to route auth at loop-pro authentication-api.
// Unset (prod default) → stay on cb-authentication-api. Per-service, so portals flip independently.
const LOOP_AUTH_URL = process.env.REACT_APP_LOOP_AUTH_URL;

export const findOrganization = async (organization: string): Promise<any> => {
  try {
    const base = (LOOP_AUTH_URL || config.uri.auth_url).replace(/\/+$/, '');
    const org = encodeURIComponent(organization);
    const path = LOOP_AUTH_URL
      ? `/api/organization/find?organization=${org}`
      : `/organization/find-organization?organization=${org}`;
    const uri = `${base}${path}`;

    const options = {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
